import React, {useEffect, useLayoutEffect, useState, useMemo, useReducer, useContext} from 'react'
import {useParams, useNavigate} from 'react-router-dom'
import OrderService from '../services/OrderService';
import {MaterialReactTable} from 'material-react-table';
import {Box, Button, ListItemIcon, MenuItem, Typography} from '@mui/material';
import {Context} from '../index';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import EntityList from "../components/EntityList";
import {toJS} from "mobx";
import MyButton from "../UI/MyButton/MyButton";
import DemandService from "../services/DemandService";
import MarkingCodeModal from "../components/MarkingCodeModal";
import ConsignmentConverter from '../utils/ConsignmentConverter';
import { READY_BUTTONS, STATES } from '../config';
import { useTranslation } from 'react-i18next';

/**
 * выводить:
 * имя, дату, способ доставки, позиции
 * name, moment/created?, attributes.find(attribute => attribute.name == 'Способ доставки NEW').value, positions
 */

export default function DemandById() {
    const {store} = useContext(Context);
    const { t } = useTranslation();
    const pagination = {
        pageSize: 100
    }
    // Use config for buttons and states (supports multi-instance deployment)
    const readyButtons = READY_BUTTONS;
    const STATES_MAP = STATES;
    const [demand, setDemand] = useState([]);
    const [rowSelection, setRowSelection] = useState({});
    let [barcodeParts, setBarcodeParts] = useState('');
    const [barcode, setBarcode] = useState({});
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const params = useParams();
    const [showPopup, setShowPopup] = useState(false);
    const [isWaitingButtonClicked, setIsWaitingButtonClicked] = useState(false);
    const [isCorrectButtonClicked, setIsCorrectButtonClicked] = useState(false);
    const [demandCorrectReason, setDemandCorrectReason] = useState("");
    const [demandWaitingReason, setDemandWaitingReason] = useState("");
    const [markingModalOpen, setMarkingModalOpen] = useState(false);
    const [currentMarkingProduct, setCurrentMarkingProduct] = useState(null);
    const [scannedConsignments, setScannedConsignments] = useState({});
    const navigate = useNavigate();
    const columns = useMemo(
        () => [
            {
                accessorKey: 'image',
                header: t('label.image'),
                size: 200,
                Cell: ({cell}) => (
                    <img
                        alt={t('msg.noImage')}
                        src={cell.getValue()}/>
                )
            },
            {
                accessorKey: 'article',
                header: t('label.article'),
                size: 200
            },
            {
                accessorKey: 'name',
                header: t('label.name'),
                size: 200,
                Cell: ({ row }) => {
                    const item = row.original;
                    const hasConsignment = item.type === 'consignment' && item.consignmentLabel;

                    return (
                        <div>
                            <div>{item.name}</div>
                            {hasConsignment && (
                                <div style={{
                                    display: 'inline-block',
                                    marginTop: '4px',
                                    padding: '2px 8px',
                                    fontSize: '11px',
                                    fontWeight: 'bold',
                                    color: '#1565c0',
                                    backgroundColor: '#e3f2fd',
                                    border: '1px solid #90caf9',
                                    borderRadius: '4px'
                                }}>
                                    {t('orders.series')} {item.consignmentLabel}
                                </div>
                            )}
                        </div>
                    );
                }
            },
            {
                accessorKey: 'quantity',
                header: t('label.quantity'),
                size: 200,
                Cell: ({cell}) => (
                    <span style={{fontSize: '20px'}}>
                        {cell.getValue()}
                    </span>
                )
            }
        ],
        [t],
    );

    useEffect(() => {
        getDemandById(params.id);
        uploadSelectedRowsFromServer();

    }, [params.id])

    async function uploadSelectedRowsFromServer() {
        try {
            const response = await store.checkEntitiesInWork();

            const orderInStore = toJS(store.entitiesInWork);
            const rowsToUpdate = orderInStore.find(item => item.id === params.id).selectedPositions;

            console.log('order in store', rowsToUpdate)

            setRowSelection({...rowsToUpdate});

        } catch (e) {
            console.log(e);
        }
    }


    useEffect(() => {
        console.log(rowSelection);
        const orderInStoree = updateSelectedPositions();

    }, [rowSelection])

    async function updateSelectedPositions() {
        const updateRows = Object.assign({}, rowSelection);
        console.log('updateRows', updateRows);
        let serverResToUpdateSelectedPositions;
        if (Object.keys(updateRows).length > 0) {
            await DemandService.updateSelectedPositions(params.id, {updateRows});
        }

        return serverResToUpdateSelectedPositions;
    }

    useEffect(() => {
        function handleKeyDown(e) {
            // Игнорируем события когда модальное окно маркировки открыто
            if (markingModalOpen) {
                return;
            }
            
            if (e.key === 'Enter') {
                setBarcode({value: parseScannedInput(barcodeParts)});
                setBarcodeParts('');
                return;
            }

            let newBarcode = barcodeParts.concat(e.key);
            setBarcodeParts(newBarcode);
        }

        document.addEventListener('keydown', handleKeyDown);

        return function cleanup() {
            document.removeEventListener('keydown', handleKeyDown);
        }
    }, [barcodeParts, markingModalOpen]);

    useEffect(() => {
        if (demand.length !== 0) {
            console.log('demand', demand);

            // Сначала ищем среди обычных штрихкодов
            let scannedProduct = demand.positions.find(position => position.barcode === barcode.value);

            // Если не найдено - ищем среди штрихкодов серий (consignmentBarcode)
            if (!scannedProduct) {
                scannedProduct = demand.positions.find(position =>
                    position.consignmentBarcode === barcode.value &&
                    position.type === 'consignment'
                );
            }

            console.log(barcode.value);
            console.log(scannedProduct);

            if (scannedProduct) {
                setBarcodeParts('');

                // Проверка на повторное сканирование серии
                if (scannedProduct.type === 'consignment' && scannedConsignments[scannedProduct.id]) {
                    setShowPopup(true);
                    return;
                }

                // Отмечаем серию как отсканированную
                if (scannedProduct.type === 'consignment') {
                    setScannedConsignments(prev => ({
                        ...prev,
                        [scannedProduct.id]: true
                    }));
                }

                // Проверка на маркированный товар
                if (scannedProduct.isMarked) {
                    console.log('Marked product detected:', scannedProduct);
                    setCurrentMarkingProduct(scannedProduct);
                    setMarkingModalOpen(true);
                    return;
                }

                // Обычная логика для немаркированных товаров
                const selectedRow = Object.assign(rowSelection, {[scannedProduct.id]: true});
                setRowSelection((selectedRow) => (selectedRow));
                console.log('selected row', selectedRow);
            } else {
                setBarcodeParts('');
                setShowPopup(true);
                return;
            }
        }
        forceUpdate();
    }, [barcode])

    async function getDemandById(id) {
        let demandIsTaken = false;
        while (!demandIsTaken) {
            try {
                const response = await DemandService.getDemandById(id);
                console.log(response);

                setDemand(response.data);
                demandIsTaken = true;

            } catch (e) {
                console.log(e);

                if (e.response?.status === 410) {
                    const errorData = e.response.data;
                    alert(`${errorData.message || t('orders.shipmentAlreadyCompleted')}`);

                    navigate('/start');
                    return;
                }
            }
        }
    }

    function parseScannedInput(input) {
        const matches = input.match(/Alt(\d+)/g);
        if (!matches) return input;

        return matches.map((code) => {
            const num = code.replace("Alt", "");
            return String.fromCharCode(parseInt(num));
        }).join('');
    }

    const handleSendToCorrect = async () => {
        try {
            const result = await DemandService.changeStatus(params.id, 'correction', demandCorrectReason);
            console.log(result);
            console.log(store.user.id);
            const serverRes = await DemandService.moveDemandToWaitingList(params.id, 'correct', demandCorrectReason);
            alert(t('orders.shipmentSentForCorrection', { name: demand.name }))
            navigate('/start')

        } catch (error) {
            alert(t('msg.errorSomethingWentWrong', { message: error.message }))
        }
    };

    const handleToWaitingList = async () => {
        const serverRes = await DemandService.moveDemandToWaitingList(params.id, 'waiting', demandWaitingReason);
        alert(t('orders.shipmentSentToWaiting', { name: demand.name }))
        navigate('/start');
    };

    // Обработчик завершения маркировки
    const handleMarkingComplete = (product) => {
        console.log('handleMarkingComplete called for product:', product.article);
        // Автоматически отметить позицию как выполненную
        const selectedRow = Object.assign(rowSelection, {[product.id]: true});
        setRowSelection(selectedRow);

        // Закрыть модальное окно
        setMarkingModalOpen(false);
        setCurrentMarkingProduct(null);

        console.log(`Marking completed for product ${product.article}`);
    };

    // Кастомный обработчик выделения строк
    const handleRowSelectionChange = (updater) => {
        const newSelection = typeof updater === 'function' ? updater(rowSelection) : updater;
        setRowSelection(newSelection);

        const selectedCount = Object.keys(newSelection).length;

        // Обрабатываем ТОЛЬКО когда выбрана ровно ОДНА строка
        if (selectedCount === 1) {
            const selectedId = Object.keys(newSelection)[0];
            const selectedProduct = demand.positions.find(position =>
                position.id === selectedId
            );

            // Если это маркированный товар - открываем модальное окно
            if (selectedProduct && selectedProduct.isMarked) {
                console.log('Marked product selected via checkbox:', selectedProduct);
                setCurrentMarkingProduct(selectedProduct);
                setMarkingModalOpen(true);
            }
        }

        // Если selectedCount === 0 или selectedCount > 1 - ничего дополнительно не делаем
        console.log('Row selection updated:', selectedCount, 'rows selected');
    };


    return (
        <div>
            {demand?.positions
                ?
                <MaterialReactTable columns={columns} data={demand.positions}
                                    enableRowSelection
                                    enableSelectAll={false}
                                    onRowSelectionChange={handleRowSelectionChange}
                                    initialState={{pagination}}
                                    getRowId={(originalRow)=> originalRow.id}
                                    state={{rowSelection}}
                                    renderTopToolbarCustomActions={({table}) => {
                                        const handleCollectOrder = async () => {
                                            try {
                                                const result = await DemandService.changeStatus(params.id, STATES_MAP.get(store.user.position));
                                                console.log(result);
                                                const removeOrderFromWork = await DemandService.removeDemandFromWork(params.id, store.user.position);
                                                console.log(removeOrderFromWork)
                                                alert(t('orders.shipmentStatusChanged', { name: demand.name, status: STATES_MAP.get(store.user.position) }))
                                                navigate('/start')
                                            } catch (error) {
                                                alert(t('msg.errorSomethingWentWrong', { message: error.message }))
                                            }
                                        };

                                        return (
                                            <div>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    marginTop: 9,
                                                    marginLeft: 35
                                                }}>{t('label.comment')} <b>{demand.description}</b></div>
                                                <div style={{display: 'flex', gap: '0.5rem'}}>
                                                    <Button
                                                        color="success"
                                                        disabled={!table.getIsAllRowsSelected()}
                                                        onClick={handleCollectOrder}
                                                        variant="contained"
                                                    >
                                                        {readyButtons[store.user.position]}
                                                    </Button>
                                                    <Button
                                                        color="error"
                                                        onClick={() => setIsCorrectButtonClicked(true)}
                                                        variant="contained"
                                                    >
                                                        {t('orders.correction')}
                                                    </Button>
                                                    <Button
                                                        color="primary"
                                                        onClick={() => setIsWaitingButtonClicked(true)}
                                                        variant="contained"
                                                    >
                                                        {t('orders.toWaiting')}
                                                    </Button>
                                                </div>
                                                <div style={{display: "flex"}}>
                                                    <div style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        marginTop: 9,
                                                        marginLeft: 35
                                                    }}>{t('orders.shipment')} <b>{demand.name}</b></div>
                                                    <div style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        marginTop: 9,
                                                        marginLeft: 35
                                                    }}>{t('orders.delivery')} <b>{demand.delivery}</b></div>
                                                    <div style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        marginTop: 9,
                                                        marginLeft: 35
                                                    }}>{t('orders.order')} <b>{demand.orderName}</b></div>
                                                </div>
                                            </div>
                                        );
                                    }}
                />
                :
                ""}
            <Popup open={showPopup} onClose={() => setShowPopup(false)}><h4> {t('orders.invalidBarcode')} </h4></Popup>
            <Popup open={isCorrectButtonClicked} onClose={() => setIsCorrectButtonClicked(false)}>
                <h2> {t('orders.specifyCorrectionReason')} </h2>
                <input
                    onChange={(e) => {
                        setDemandCorrectReason(e.target.value)
                    }}
                    name={"correct_reason"}
                    value={demandCorrectReason}
                    type="text"
                    placeholder={t('orders.correctionReasonPlaceholder')}
                />
                <MyButton onClick={() => handleSendToCorrect()}> {t('btn.send')} </MyButton>
            </Popup>
            <Popup open={isWaitingButtonClicked} onClose={() => setIsWaitingButtonClicked(false)}>
                <h2> {t('orders.specifyWaitingReason')} </h2>
                <input
                    onChange={(e) => {
                        setDemandWaitingReason(e.target.value)
                    }}
                    name={"waiting_reason"}
                    value={demandWaitingReason}
                    type="text"
                    placeholder={t('orders.waitingReasonPlaceholder')}
                />
                <MyButton onClick={() => handleToWaitingList()}> {t('btn.send')} </MyButton>
            </Popup>
            
            {/* Модальное окно для сканирования кодов маркировки */}
            <MarkingCodeModal
                isOpen={markingModalOpen}
                onClose={() => {
                    console.log('MarkingCodeModal onClose called!');
                    setMarkingModalOpen(false);
                    setCurrentMarkingProduct(null);
                }}
                demand={demand}
                product={currentMarkingProduct}
                onComplete={handleMarkingComplete}
            />
        </div>
    )
}
